import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import ClipLoader from 'react-spinners/ClipLoader';
import { Button, Checkbox, Col, Input, Row, Select } from 'antd';
import { observer } from 'mobx-react';
import { useStores } from '@gtintel/platform-stores';
import * as S from './styles';
const LABELS = {
  additional_info: 'Additional Info',
  address: 'Address',
  dob: 'DOB',
  email: 'Email',
  jurisdiction: 'Jurisdiction',
  is_entity: 'Is entity',
  is_individual: 'Is individual',
  is_online: 'Is online',
  is_rural: 'Is rural',
  is_source_of_wealth: 'Is source of wealth enquiry',
  phone_number: 'Phone number',
  report_type: 'Report type',
  service_name: 'Service name',
  site_name: 'Site name',
  social_media: 'Social media',
  social_media_review: 'Is social media review',
  tax_id: 'Tax ID'
};

// 0: Document Retrieval
// 1: Site Visit
// 2: Due Diligence
// 3: Human Source Enquiry
// 9: Something Else
const TEXTAREAS_FOR_SERVICE_TYPE = {
  null: ['additional_info'],
  '0': ['additional_info'],
  '1': ['address'],
  '2': ['additional_info'],
  '3': ['additional_info'],
  '9': ['additional_info']
};

// All types have Jurisdictions field; not all allow multiple Js to be selected
const ALLOWS_MULTIPLE_JURISDICTIONS = {
  null: true,
  '0': true,
  '1': false,
  '2': true,
  '3': false,
  '9': true
};
const TEXT_INPUTS_FOR_SERVICE_TYPE = {
  null: [],
  '0': [],
  '1': ['site_name'],
  '2': ['service_name'],
  '3': [],
  '9': []
};
const CHECKBOXES_FOR_SERVICE_TYPE = {
  null: [],
  '0': ['is_entity', 'is_individual'],
  '1': ['is_rural'],
  '2': ['is_entity', 'is_individual'],
  '3': [],
  '9': []
};
const Errors = ({
  errors,
  name
}) => {
  if (!errors) return null;
  return <>
      {errors[name] && errors[name].type === 'required' && <S.Error>This field is required</S.Error>}
      {errors[name] && errors[name].type === 'maxLength' && <S.Error>Too long</S.Error>}
    </>;
};
const FormField = ({
  control,
  errors,
  label,
  name,
  initialValue,
  renderInput
}) => <S.FormItem>
    <label>
      {label}
      <Controller name={name} control={control} defaultValue={initialValue} render={renderInput} />
      <Errors errors={errors} name={name} />
    </label>
  </S.FormItem>;
const EditProjectSubjectForm = ({
  jurisdictions,
  onCancel,
  subject
}) => {
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    isLoading
  } = adminProjectDetailStore;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    handleSubmit,
    control,
    formState: {
      errors
    }
  } = useForm();
  const onSubmit = async data => {
    setIsSubmitting(true);
    if (Array.isArray(data.jurisdiction)) data.jurisdiction = data.jurisdiction.join(',');
    await adminProjectDetailStore.updateProjectDescription(String(subject.id), data);
    setIsSubmitting(false);
  };
  const canSubmit = !(isLoading || isSubmitting);
  const initialJurisdictions = ALLOWS_MULTIPLE_JURISDICTIONS[subject.service_type] ? subject.jurisdiction?.split(',') : subject.jurisdiction;
  return <form name="basic" onSubmit={handleSubmit(onSubmit)} className="edit-project-detail-form">
      {TEXTAREAS_FOR_SERVICE_TYPE[subject.service_type].map((attr, i) => <FormField control={control} errors={errors} initialValue={subject[attr]} key={i} label={LABELS[attr]} name={attr} renderInput={({
      field: {
        onChange,
        value
      }
    }) => <Input.TextArea onChange={onChange} placeholder={LABELS[attr]} value={value} />} />)}

      {TEXT_INPUTS_FOR_SERVICE_TYPE[subject.service_type].map((attr, i) => <FormField control={control} errors={errors} initialValue={subject[attr]} key={i} label={LABELS[attr]} name={attr} renderInput={({
      field: {
        onChange,
        value
      }
    }) => <Input placeholder={LABELS[attr]} value={value} onChange={onChange} />} />)}

      <S.FormItem>
        <label>
          Jurisidiction(s)
          <Controller name="jurisdiction" control={control} defaultValue={initialJurisdictions} render={({
          field: {
            onChange,
            value
          }
        }) => <Select data-testid="jurisdiction-select" mode={ALLOWS_MULTIPLE_JURISDICTIONS[subject.service_type] ? 'multiple' : null} showArrow onChange={onChange} value={value} showSearch style={{
          width: '100%'
        }}>
                {jurisdictions.map(juris => <Select.Option data-testid={`jurisdiction-option-${juris.id}`} key={juris.id} value={juris.name}>
                    {juris.name}
                  </Select.Option>)}
              </Select>} />
        </label>
      </S.FormItem>

      {CHECKBOXES_FOR_SERVICE_TYPE[subject.service_type].map((attr, i) => <FormField control={control} errors={errors} initialValue={subject[attr]} key={i} name={attr} renderInput={({
      field: {
        onChange,
        value
      }
    }) => <Checkbox onChange={onChange} checked={value}>
                {LABELS[attr]}
              </Checkbox>} />)}

      <S.FormItem>
        <Row>
          <Col>
            <div>
              <Button htmlType="submit" type="primary">
                {canSubmit ? 'UPDATE PROJECT' : <ClipLoader size={14} color="#FFFFFF" />}
              </Button>
            </div>
          </Col>
          <Col>
            {!isSubmitting && <div>
                <Button type="text" onClick={onCancel}>
                  CANCEL
                </Button>
              </div>}
          </Col>
        </Row>
      </S.FormItem>
    </form>;
};
export default observer(EditProjectSubjectForm);